<template>
  <v-content>
    <v-container
      class="mt-2"
      fluid
      v-if="isReady"
    >
      <pageTitle>
        Maps
      </pageTitle>
      <blockTitle>
        GeoChart
      </blockTitle>
      <blockContent>
        <gChart
          :settings="chart.settings"
          type="GeoChart"
          :data="chart.data"
          :options="chart.options"
          :events="{regionClick: clickRegion}"
          @ready="onGeoChartReady"
        />
      </blockContent>
      <blockTitle>
        Members
      </blockTitle>
      <blockContent>
        <v-list>
          <v-list-item
            v-for="item in users"
            :key="item.uid"
            @click="$router.push(`/profile/${item.uid}`)"
          >
            <v-list-item-avatar>
              <v-img :src="item.photoUrl"></v-img>
            </v-list-item-avatar>
            <v-list-item-content>
              <v-list-item-title v-text="item.nickname"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </blockContent>
    </v-container>

    <bottomNavigation
      activeNav="favorite"
    ></bottomNavigation>
  </v-content>
</template>

<script>
// import firebase from "firebase/app"
import LikeCol from '@/components/Like/LikeCol'
import BottomNavigation from '@/components/Like/BottomNavigation'
import service from '@/plugins/service'
import pageTitle from '@/components/Like/PageTitle'
import blockTitle from '@/components/Like/BlockTitle'
import blockContent from '@/components/Like/BlockContent'
import { GChart } from 'vue-google-charts'

export default {
  components: {
    LikeCol,
    BottomNavigation,
    pageTitle,
    blockTitle,
    blockContent,
    GChart,
  },
  data: () => ({
    isReady: false,
    user: {},
    chart: {
      settings: {
        packages: ['geochart'],
        mapsApiKey: 'AIzaSyC1-NtffE5dsko8YPnmeqDngENGOvL8oq8',
      },
      data: [
        ['Country', 'Popularity'],
      ],
      options: {
        resolution: 'previnces',
        displayMode: 'country',
        colorAxis: {colors: ['#FFF0D8', '#FF5500']}
      }
    },
    users: [],
  }),
  async mounted() {
    // ログインチェック
    try {
      this.user = await service.authCheck()
    } catch (e) {
      this.$router.push('/')
      return
    }
    // 管理者チェック
    const json = await service.getPassions({
      uid: this.user.uid,
      target: 'name',
    })
    if (!json.key) {
      this.$router.push('/')
      return
    }
    this.isReady = true
  },
  methods: {
    async onGeoChartReady(chart, google) {
      const json = await service.getUsersAreas()
      const data = new google.visualization.DataTable()
      data.addColumn('string', 'Country')
      data.addColumn('number', 'members')
      json.list.forEach(item => {
        console.log(item)
        data.addRow([
          item[0],
          parseInt(item[1]),
        ])
      })
      this.chart.data = data
      /*
      chart.draw(
        data, {
        resolution: 'countries',
        displayMode: 'regions',
        colorAxis: {
          minValue: 0,
          colors: [
            '#FFFFFF', '#FF5500'
          ]
        },
      })
      */
    },
    async clickRegion(region) {
      const json = await service.getUsersAreas(region.region)
      this.users.splice(0);
      json.list.forEach(item => this.users.push(item))
    },
  }
}
</script>

<style lang="stylus" scoped>
div.no-passion-shots-yet
  margin 32px auto
  div.title
    font-style normal
    font-weight normal
    font-size 16px !important
    line-height 22px
    align-items center
    text-align center
    letter-spacing -0.0241176em
    color #0C0B0B
  div.message
    margin 8px auto
    font-style normal
    font-weight normal
    font-size 15px !important
    line-height 22px
    width 200px
    align-items center
    text-align center
    letter-spacing -0.0241176em
    color #929191
  div.img
    margin 24px auto 24px auto
    text-align center
</style>
